import type { DwhListingType, DwhShare, PatchDwhShareRequest } from "../../../api/types/integrationsTypes";

export type UpdateShareFormFields = keyof UpdateShareForm;

interface UpdateShareForm {
  description: string;
}

export const initialUpdateShareForm = (share: DwhShare): UpdateShareForm => ({
  description: share.description ?? "",
});

export const mapUpdateShareFormToRequest = (form: UpdateShareForm): PatchDwhShareRequest => ({
  description: form.description.trim() || undefined,
});

export const isFormEdited = (form: UpdateShareForm, share: DwhShare): boolean =>
  form.description.trim() !== (share.description?.trim() ?? "");

export const formatDwhShareType = (type: DwhListingType) => {
  switch (type) {
    case "AllTables":
    case "AllTablesOrgLevel":
      return "All Tables";
    case "Qashqade":
      return "Qashqade";
    case "Cascata":
      return "Cascata";
    case "PortfolioMonitoring":
      return "Portfolio Monitoring";
    default:
      return type;
  }
};
